export const toSentenceCase = (str: string): string => {
  str = str.replace(/([A-Z])/g, " $1");

  return str.replace(/^./, (str) => str.toUpperCase());
};

export const camelCaseToTitleCase = (str: string): string => {
  str = str.replace(/([A-Z])/g, " $1");
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
};

export const truncate = (
  completeString: string,
  start: number,
  end: number
): string => {
  const stringLength = completeString.length;

  // Return original string if truncation is not possible
  if (stringLength < start + end) {
    return completeString;
  }

  if (start && end) {
    // Truncate middle
    return `${completeString.substring(0, start)}...${completeString.substring(
      stringLength - end
    )}`;
  }
  if (end) {
    // truncate start
    return `...${completeString.substring(stringLength - end)}`;
  }

  // truncate end
  return `${completeString.substring(0, start)}...`;
};
